import React from 'react';
import { motion } from 'framer-motion'; // Import Framer Motion
import './Steps.css';
import img1 from '../../../Images/nerddos.jpg';
import { Link } from 'react-router-dom';


const Steps = () => {
  return (
    <div className="our-work-cover">
      <div className="our-work-content">
        <div className="our-work-image">
          <motion.img 
            src={img1} 
            alt="Landing" 
            whileHover={{ scale: 1.05 }} // Scale on hover
            transition={{ duration: 0.3 }}
          />
        </div>
        <div className="our-work-wording">
          <h3>WHAT WE DO</h3>
          <h1>Making Mondays feel like Fridays one solution at a time</h1>
          <ol className="steps-list">
            <li>
              <h4>Create an account.</h4>
              <p>It’s free to sign up. You’ll pick your plan and add your company details.</p>
            </li>
            <li>
              <h4>Add your people.</h4>
              <p>Add your employee details. They can even self-onboard to save you time.</p>
            </li>
            <li>
              <h4>Run your first payroll.</h4>
              <p>Once we have your employee and tax info, you can run payroll in just a few clicks.</p>
            </li>
          </ol>
          <div className="cta">
            <motion.button
              whileHover={{ scale: 1.05 }} // Scale on hover
              whileTap={{ scale: 0.95 }} // Scale down on tap
              transition={{ duration: 0.2 }}
            >
                  <Link style={{color: "white", textDecoration : "none"}} className='link' to="/login">Create Account</Link>
              
            </motion.button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Steps;


// import "./Steps.css"
// import img1  from "../../../Images/Landing.jpg"

// function Steps(){  
//     return <>

//             <div className="OurWorkCover">

//                 <div className="OurWorkContent">

//                         <div className="OurWorkImage">

//                             <img src={img1} />

//                         </div>
//                         <div className="OurWorkWording">
//                             <h3>WHAT WE DO</h3>
//                             <h1>Making Mondays feel like Fridays one solution at a time</h1>
//                            <p>Create an account.</p> 
//                            <p>It’s free to sign up. You’ll pick your plan and add your company details.</p>

//                            <p>Add your people.</p>  
//                            <p>Add your employee details. They can even self-onboard to save you time.</p>

//                            <p>Run your first payroll.</p>
//                            <p>Once we have your employee and tax info, you can run payroll in just a few clicks.</p>
                            
//                             <div className="CTA">
                                
//                                   <button>Create account</button>

//                             </div>
//                         </div>
                        

//                 </div>

                  

     
//          </div>
   
        
//     </>

// }

// export default Steps;